import {Component, OnInit, Input, EventEmitter, Output, AfterViewInit} from '@angular/core';
import { InteractionReportData, ReportSectionEnum} from '../../../../../models/measure/report';
import {CommonConstant} from '../../../../app.constants';
import {PdfExportService} from '../../../../services/export-pdf/pdf-export.service';

@Component({
  selector: 'interaction-report',
  templateUrl: './interaction-report.component.html',
  styleUrls: ['./interaction-report.component.scss']
})
export class InteractionReportComponent implements AfterViewInit, OnInit {
  static COMPONENT_NAME = 'InteractionReportComponent';

  @Input() data: InteractionReportData = new InteractionReportData();
  // only use for PDF export. This indicate the index of current component
  @Input() pageIndex: number;
  @Input() numOfItemPerPage = CommonConstant.MAX_ITEM_PER_PAGE_REPORT;
  @Output() changePage: EventEmitter<any> = new EventEmitter<any>();
  public currentPage = 1;

  constructor(private pdfService: PdfExportService) {

  }

  ngOnInit() {
    // REVIEW: @Trung, is this the right way to do this?
    if (this.data && Array.isArray(this.data.posts)) {
      this.data.posts = this.data.posts.map(p => Object.assign({}, p, {
        relativepath: encodeURIComponent(p.relativepath),
        url: encodeURIComponent(p.url)
      }));
    }
  }

  ngAfterViewInit() {
    if (this.data.posts.length === 0) {
      this.pdfService.incrementNumberReportReady(`${InteractionReportComponent.COMPONENT_NAME}${this.pageIndex}`);
      return;
    }

    this.pdfService.imagedLoadedTrigger.subscribe(data => {
      if (data.component === `${InteractionReportComponent.COMPONENT_NAME}${this.pageIndex}`
        && data.currentCounter === this.data.posts.length) {
        this.pdfService.incrementNumberReportReady(`${InteractionReportComponent.COMPONENT_NAME}${this.pageIndex}`);
      }
    });
  }

  get haveNoData() {
    return this.data.posts.length === 0 && (!this.pageIndex || this.pageIndex === 0);
  }

  onChangePage(evt) {
    this.changePage.emit({
      reportSection: ReportSectionEnum.INTERACTION_REPORT,
      criteriaChange: {page_no: evt}
    });
  }

  get maxPage() {
    if (!this.data || !this.data.totalRows) {
      return 0;
    }
    const totalFullPage = Math.floor(this.data.totalRows / this.numOfItemPerPage);
    const hasPartialPage = (this.data.totalRows % this.numOfItemPerPage) > 0;
    return hasPartialPage ? totalFullPage + 1 : totalFullPage;
  }

  calculateIndex(index) {
    // in pdf mode
    if (this.pageIndex === 0) {
      return this.pageIndex * CommonConstant.MAX_ROI_ITEM_IN_PDF_PAGE + index + 1;
    } else if (this.pageIndex > 0) {
      return this.pageIndex * CommonConstant.MAX_ROI_ITEM_IN_PDF_PAGE + index + this.pageIndex - 1;
    } else if (this.data.pageNo) {
      return (this.data.pageNo - 1) * this.numOfItemPerPage + index + 1;
    } else {
      return this.numOfItemPerPage + index + 1;
    }
  }

  get isExportingPdfReport() {
    return this.pdfService.exportingPdf;
  }

  get shouldShowHeader() {
    return !this.pageIndex || this.pageIndex === 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/main/measure/contents/interaction-report/interaction-report.component.ts